import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { Observable, catchError, map, throwError } from 'rxjs';
import { StampingPartnersModel } from '../models/stampingpartner.models';
import { TokenStorageService } from './token-storage.service';


const BASE_URL = GlobalComponent.BASE_API_URL;
const AUTH_API = BASE_URL + GlobalComponent.AUTH_API;

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({ providedIn: 'root' })

/**
 * Stampingpartner-service Component
 */
export class StampingpartnerService {

    constructor(private http: HttpClient, private tokenService: TokenStorageService) {
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    registerStampingPartner(email: string, password?: string, name?: string, encryptedemail?: string, encryptedname?: string) { 
        let currentuser = this.tokenService.getCurrentUser();
        let vendorGUID = this.tokenService.getVendorGUID();
         const postData = {
             username: email,
             email: email,
             password: password,
             role: GlobalComponent.ROLES.Superadmin,
             usertype: GlobalComponent.USERTYPE.StampingPartner,
             provider: 'local',
             source: 'web',
             registereddomain: email.substring(email.lastIndexOf('@') + 1),
             name: name,
             masterguid: currentuser && currentuser?.user ? currentuser?.user?.masterguid : vendorGUID ? vendorGUID : null,
             vendorguid: vendorGUID,
             subdomain: window.location.host,
             encryptedemail: encryptedemail,
             encryptedname: encryptedname
           };
         // Register Api
         return this.http.post(AUTH_API + 'local/register', postData, httpOptions).pipe(
             map((response: any) => {
                 const user = response;
                 return user;
             }),
             catchError((error: any) => {
                 return throwError(() => error);
             })
         );
     }

    // Get Stampingpartners
    getStampingpartnersData(isblocked: boolean, limit: number, skip: number) : Observable<StampingPartnersModel> {
        return this.http.get<StampingPartnersModel>(BASE_URL + GlobalComponent.vendorStampingpartnersGet + "?blocked=" + isblocked + "&orderby=DESC&skip="+skip+"&limit="+limit);
    }

    updateStampingpartnersProfile(guid: string, data: any): Observable<any> {
        return this.http.put(BASE_URL + `client/update-profile/${guid}`, data);
    }

    /**
     * Onboarding API(PUT)
     */
    onboardingComplete(companyname: string, address: string, userguid: string, oprstates: any, encryptedcompany: string, encryptedaddress: string) {
        const postData = {
            company: companyname,
            address: address || '',
            guid: userguid,
            oprstates: oprstates,
            encryptedcompany: encryptedcompany,
            encryptedaddress: encryptedaddress
          };
        return this.http.put(BASE_URL + 'stampingpartner/onboarding/profile', postData);
    }
}